import { type OrganizationType, organizationType } from '@openx/types/organization';
import { useAuth } from '../../../components/AuthContext/context';

export function useMatchesOrganizationType(providedOrganizationType: OrganizationType) {
  const { session } = useAuth();

  const orgType = session?.account.organization_type || organizationType.TechPartner;
  return providedOrganizationType === orgType;
}
